import { render, staticRenderFns } from "./CostModal.vue?vue&type=template&id=2837c6f4&"
import script from "./CostModal.vue?vue&type=script&lang=ts&"
export * from "./CostModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports